import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const Navbar: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const links = [
    { label: 'Why Us', href: '#why-us' },
    { label: 'Mission', href: '#mission' },
    { label: 'Works', href: '#works' },
    { label: 'Services', href: '#services' },
    { label: 'Team', href: '#team' },
  ];

  return (
    <motion.nav
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'bg-[#080808]/85 backdrop-blur-xl border-b border-[#141414]' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <a href="#hero" className="flex items-center gap-2.5 group">
          <img src="/logo.png" alt="SiteStackCo" className="h-10 w-auto object-contain" />
          <span className="font-syne font-bold text-white text-base hidden sm:block">
            SiteStack<span className="text-lime">Co</span>
          </span>
        </a>

        <ul className="hidden md:flex items-center gap-8">
          {links.map((l, i) => (
            <motion.li key={l.label}
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 + i * 0.07 }}
            >
              <a href={l.href} className="font-dm text-sm text-[#aaa] hover:text-white transition-colors duration-200 relative group">
                {l.label}
                <span className="absolute -bottom-0.5 left-0 w-0 h-px bg-lime group-hover:w-full transition-all duration-300" />
              </a>
            </motion.li>
          ))}
        </ul>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="hidden md:block"
        >
          <a href="#contact" className="btn-lime px-5 py-2.5 text-sm">Let's Talk</a>
        </motion.div>

        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden flex flex-col gap-1.5 p-2 z-50"
        >
          <span className={`block w-5 h-0.5 bg-white transition-all duration-300 origin-center ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
          <span className={`block w-5 h-0.5 bg-white transition-all duration-300 ${menuOpen ? 'opacity-0 scale-x-0' : ''}`} />
          <span className={`block w-5 h-0.5 bg-white transition-all duration-300 origin-center ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
        </button>
      </div>

      <AnimatePresence>
        {menuOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="md:hidden bg-[#0a0a0a] border-t border-[#141414] overflow-hidden"
          >
            <ul className="flex flex-col gap-0 px-6 py-6">
              {links.map((l, i) => (
                <motion.li
                  key={l.label}
                  initial={{ x: -20, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ delay: i * 0.06 }}
                  className="border-b border-[#141414] py-4"
                >
                  <a
                    href={l.href}
                    className="font-syne text-sm text-[#888] hover:text-white transition-colors"
                    onClick={() => setMenuOpen(false)}
                  >
                    {l.label}
                  </a>
                </motion.li>
              ))}
              <li className="pt-5">
                <a href="#contact" className="btn-lime px-6 py-2.5 text-sm" onClick={() => setMenuOpen(false)}>
                  Let's Talk
                </a>
              </li>
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.nav>
  );
};

export default Navbar;
